import React from "react";
import SvgInterface from "@shared/lib/interfaces/SvgInterface";

export default React.memo(function DeleteImgIcon({ ...other }: SvgInterface) {
    return (
        <svg
            onClick={other.onClick}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="0.25"
                y="0.25"
                width="23.5"
                height="23.5"
                rx="11.75"
                fill="white"
                stroke="#CCD2E1"
                stroke-width="0.5"
            />
            <path
                d="M16.46 8.52999C16.7338 8.25622 16.7338 7.81235 16.46 7.53858C16.1863 7.26481 15.7424 7.26481 15.4686 7.53858L11.9987 11.0085L8.52877 7.53858C8.25499 7.26481 7.81113 7.26481 7.53736 7.53858C7.26359 7.81235 7.26359 8.25622 7.53736 8.52999L11.0073 11.9999L7.53736 15.4698C7.26359 15.7436 7.26359 16.1875 7.53736 16.4613C7.81113 16.735 8.255 16.735 8.52877 16.4613L11.9987 12.9913L15.4686 16.4613C15.7424 16.735 16.1863 16.735 16.46 16.4613C16.7338 16.1875 16.7338 15.7436 16.46 15.4698L12.9901 11.9999L16.46 8.52999Z"
                fill="#F86A6A"
            />
        </svg>
    );
});